module.exports = __webpack_public_path__ + "static/media/ecoswitch_icon_white.12c7292f.png";